import React, { useContext } from 'react';
import styled from 'styled-components';

import { UniversalSearchContext } from 'contexts';
import { useBreakpoint } from 'hooks';
import Icon from '../Icon';
import Space from '../Space';
import Button from '../Button';

type StopRowActionsProps = {
  latitude: string;
  longitude: string;
  googlePlaceId: string;
  index: number;
};

const viewOnGoogleMap = (
  latitude: string,
  longitude: string,
  googlePlaceId: string,
) => {
  window.open(
    `https://www.google.com/maps/search/?api=1&query=${latitude}%2C${longitude}&query_place_id=${googlePlaceId}`,
  );
};

const StopRowActions: React.FC<StopRowActionsProps> = ({
  latitude,
  longitude,
  googlePlaceId,
  index,
}) => {
  const { activeRow } = useContext(UniversalSearchContext);
  const { md } = useBreakpoint();
  if (index !== activeRow && md) return null;

  return (
    <Space>
      <StyledButtonWrapper>
        <Button
          icon={<Icon type="eye" color="black" offset={[0, 2]} />}
          data-cy="stop-view-button"
          onClick={e => {
            e.stopPropagation();
            viewOnGoogleMap(latitude, longitude, googlePlaceId);
          }}
        >
          {md && 'View on Google'}
        </Button>
      </StyledButtonWrapper>
    </Space>
  );
};

export default StopRowActions;

const StyledButtonWrapper = styled.div`
  margin-right: 10px;
  & ${Button} {
    border-radius: 50px;
  }
`;
